import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { rowDetailType } from "./MemberInfoTable";
import api from "../../../API";
import { useSelector } from "react-redux";

interface userDetailProps {
  // dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: rowDetailType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<rowDetailType>>;
  getMemberList: any;
}

const initailData: rowDetailType = {
  id: 0,
  email: "",
  name: "",
  birth: "",
  gender: "",
  phone: "",
  startDate: "",
  roles: [],
};

const UserDetail = (props: userDetailProps) => {
  console.log("props", props);
  const [data, setData] = useState<rowDetailType>(initailData);

  const [auths, setAuths] = useState([]);

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
  };

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const memberUpdate = async () => {
    // Preventing the page from reloading
    // event.preventDefault();

    // Do something
    console.log(data);

    var result = await api.post("/memberUpdate", data);

    console.log("axios post result ", result);

    // close the dialog

    props.setDialogOpen(false);
    props.getMemberList();
  };

  useEffect(() => {
    getAuths();
    console.log("useEffect");
    if (props.rowDetail != null) setData(props.rowDetail);
  }, [props.rowDetail]);

  return (
    <Dialog maxWidth="xs" open={true}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent dividers>
        {/* <form id="dialogForm"> */}
        <TextField
          id="name"
          value={data.name}
          label="이름"
          variant="standard"
          onChange={(e: any) =>
            setData((preData) => ({ ...preData, name: e.target.value }))
          }
        />
        <TextField
          id="email"
          value={data.email}
          type="email"
          label="이메일"
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          id="birth"
          value={data.birth}
          label="생년월일"
          variant="standard"
          onChange={(e: any) =>
            setData((preData) => ({ ...preData, birth: e.target.value }))
          }
        />
        <TextField
          id="gender"
          value={data.gender}
          label="성별"
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          id="phone"
          value={data.phone}
          label="전화번호"
          type="tel"
          variant="standard"
          onChange={(e: any) =>
            setData((preData) => ({ ...preData, phone: e.target.value }))
          }
        />
        <TextField
          id="startDate"
          value={data.startDate}
          label="가입일"
          variant="standard"
        />
        <Box>
          <List
            dense
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          >
            {auths.length !== 0 ? (
              auths.map((auth: any) => {
                const labelId = `checkbox-list-secondary-label-${auth.code_nm}`;
                return (
                  <ListItem
                    key={auth.code}
                    secondaryAction={
                      <Checkbox
                        edge="end"
                        id={auth.code}
                        checked={data.roles.includes(auth.code)}
                        inputProps={{ "aria-labelledby": labelId }}
                        onChange={(e: any) =>
                          setData((preData) => {
                            var edit_roles = preData.roles;

                            if (edit_roles.includes(auth.code)) {
                              edit_roles = edit_roles.filter(
                                (v: string) => v != auth.code
                              );
                            } else {
                              edit_roles = edit_roles.concat(auth.code);
                            }
                            console.log("edit_roles", edit_roles);
                            return { ...preData, roles: edit_roles };
                          })
                        }
                      />
                    }
                    disablePadding
                  >
                    <ListItemButton>
                      <ListItemText id={labelId} primary={`${auth.code_nm}`} />
                    </ListItemButton>
                  </ListItem>
                );
              })
            ) : ""}
          </List>
        </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.setDialogOpen(false); props.setRowDetail(initailData);
          }}
        >
          No
        </Button>
        <Button
          onClick={() => {
            memberUpdate();
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDetail;
